/* Cloud Store CBD · accueil v3 : ajout au panier, fumée et entrée du podium, apparitions au défilement (vanilla, sans librairie) */
(function () {
  if (window.__hv3) return;
  window.__hv3 = 1;
  var d = document, root = d.documentElement, io = 'IntersectionObserver' in window,
      still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('hv3-js');
  var en = (root.lang || '').slice(0, 2) === 'en';
  function say(t) { var l = d.getElementById('hv3-live'); if (l) l.textContent = t; }

  /* 1. Ajout au panier : même appel que cs-product-card, puis cart:added (cs-cart.js ouvre le tiroir panier) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hv3-add]');
    if (!b || b.disabled) return;
    var name = (b.getAttribute('aria-label') || '').replace(/^(?:Ajouter|Add) | (?:au panier|to cart)$/g, '');
    var lbl = b.querySelector('.hv3-lbl');
    var lbl0 = lbl ? lbl.textContent : '';
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: b.getAttribute('data-variant-id'), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok || (data && data.status >= 400)) {
            var er = new Error('refused');
            er.msg = r.status === 422 && data && data.description;
            throw er;
          }
          return data;
        });
      })
      .then(function () {
        b.classList.add('hv3-added');
        if (lbl) lbl.textContent = en ? 'Added' : 'Ajouté';
        say(en ? name + ' added to cart' : name + ' ajouté au panier');
        d.dispatchEvent(new CustomEvent('cart:refresh'));
        d.dispatchEvent(new CustomEvent('cart:added', { detail: { source: b } }));
        setTimeout(function () { b.classList.remove('hv3-added'); if (lbl) lbl.textContent = lbl0; b.disabled = false; }, 1800);
      })
      .catch(function (er) {
        b.disabled = false;
        say((er && er.msg) || (en ? "Couldn't add it, please try again." : "L'ajout n'a pas marché, réessaie."));
      });
  });

  /* 1b. Bandeau du haut : si un segment passe à la ligne (petit écran, anglais), le « · » est masqué pour ne jamais rester seul en bout de ligne.
     On mesure toujours séparateurs visibles (classe retirée avant), donc pas de va-et-vient. */
  var info = d.querySelector('.hv3-bar__info');
  function barFix() {
    var s = info.querySelectorAll('.hv3-bar__s'), vs = [], i;
    info.classList.remove('hv3-wrapped');
    for (i = 0; i < s.length; i++) if (s[i].offsetParent !== null) vs.push(s[i]);
    for (i = 1; i < vs.length; i++) if (vs[i].offsetTop > vs[i - 1].offsetTop + 2) { info.classList.add('hv3-wrapped'); return; }
  }
  if (info) {
    barFix();
    var bt;
    addEventListener('resize', function () { clearTimeout(bt); bt = setTimeout(barFix, 120); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(barFix);
  }

  if (!io) return;

  /* 2. Fumée du podium (une traversée lente, finie) : tourne seulement quand il est à l'écran et que l'onglet est visible */
  var pod = d.querySelector('.hv3-podium'), vis = false;
  function sync() { if (pod) pod.classList.toggle('hv3-live', vis && !d.hidden); }
  if (pod) {
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; sync(); }).observe(pod);
    d.addEventListener('visibilitychange', sync);
  }
  if (still) return;

  /* 2b. Entrée du podium : jouée une seule fois, quand ~60 % de la scène est à l'écran (35 % si la scène est plus haute que 90 % de l'écran, ex. téléphone en paysage),
     après décodage des 3 photos (900 ms max) pour qu'aucune marche ne monte avec un cercle vide ; onglet masqué = on attend son retour. Sans JS ou en mouvement réduit : état final, rien de masqué. */
  if (pod) {
    pod.classList.add('hv3-arm');
    var pimgs = [].slice.call(pod.querySelectorAll('.hv3-st__ph img'));
    var play = function () {
      if (d.hidden) { d.addEventListener('visibilitychange', function w() { if (d.hidden) return; d.removeEventListener('visibilitychange', w); play(); }); return; }
      pod.classList.replace('hv3-arm', 'hv3-in');
    };
    var go = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      go.disconnect();
      var fired = false, once = function () { if (!fired) { fired = true; play(); } };
      Promise.all(pimgs.map(function (i) { return i.decode ? i.decode().catch(function () {}) : 0; })).then(once);
      setTimeout(once, 900);
    }, { threshold: Math.min(0.6, Math.max(0.35, (innerHeight * 0.9) / Math.max(pod.offsetHeight, 1))) });
    go.observe(pod);
  }

  /* 3. Apparition au défilement : uniquement ce qui est sous le 1er écran (jamais H1 ni podium) */
  var seen = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.remove('hv3-pre'); seen.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  d.querySelectorAll('.hv3-tiles li,.hv3-posts li,.hv3-av,.hv3-rung,.hv3-checks li').forEach(function (el) {
    if (el.getBoundingClientRect().top < innerHeight) return;
    el.style.setProperty('--i', Math.min([].indexOf.call(el.parentNode.children, el), 5));
    el.classList.add('hv3-pre');
    seen.observe(el);
  });
})();
